import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
type Tile = {
  index: string;
  name: string;
  image: string;
};
const TILES: Tile[] = [{
  index: '01',
  name: 'Fashion',
  image: 'https://images.unsplash.com/photo-1496747611176-843222e1e57c?auto=format&fit=crop&w=800&q=80'
}, {
  index: '02',
  name: 'Licensing',
  image: 'https://images.unsplash.com/photo-1558769132-cb1aea458c5e?auto=format&fit=crop&w=800&q=80'
}, {
  index: '03',
  name: 'Manufacturing',
  image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=800&q=80'
}, {
  index: '04',
  name: 'POD',
  image: 'https://images.unsplash.com/photo-1523381210434-271e8be1f52b?auto=format&fit=crop&w=800&q=80'
}, {
  index: '05',
  name: 'Retail Drops',
  image: 'https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=800&q=80'
}, {
  index: '06',
  name: 'Influencers',
  image: 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?auto=format&fit=crop&w=800&q=80'
}];
type CategoryTilesProps = {
  onSelect?: (name: string) => void;
};
/** Clickable tiles to explore every category we do. */
export function CategoryTiles({
  onSelect
}: CategoryTilesProps) {
  return <section className="relative w-full bg-black px-5 py-16 sm:px-8 lg:px-12" data-id="element-8">
      <div className="mx-auto max-w-7xl" data-id="element-9">
        <Reveal data-id="element-10">
          <span className="text-xs font-medium uppercase tracking-[0.3em] text-white/40" data-id="element-11">
            What We Do
          </span>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-12">
          {TILES.map((t, i) => <Reveal key={t.name} delay={i * 0.05} data-id="element-13">
              <a href="#collections" onClick={() => onSelect?.(t.name)} className="group relative flex h-40 items-end overflow-hidden rounded-xl border border-white/10" data-id="element-14">
                <img src={t.image} alt={t.name} className="absolute inset-0 h-full w-full object-cover opacity-45 transition-all duration-700 group-hover:scale-105 group-hover:opacity-70" data-id="element-15" />
                <div className="absolute inset-0 bg-gradient-to-tr from-black via-black/50 to-transparent" data-id="element-16" />
                <span className="absolute left-5 top-4 font-archivo text-xs tabular-nums text-white/60" data-id="element-17">
                  {t.index}
                </span>
                <div className="relative z-10 flex w-full items-center justify-between p-5" data-id="element-18">
                  <h3 className="font-display text-2xl uppercase leading-none tracking-tight text-white sm:text-3xl" data-id="element-19">
                    {t.name}
                  </h3>
                  <ArrowRightIcon className="h-5 w-5 text-white/60 transition-all duration-300 group-hover:translate-x-1 group-hover:text-white" data-id="element-20" />
                </div>
              </a>
            </Reveal>)}
        </div>
      </div>
    </section>;
}